import React from 'react';
import * as Yup from 'yup';
import { forEach } from 'lodash';
import ErrorMessage from 'components/form/ErrorMessage';

/* eslint-disable import/prefer-default-export */
const withRequired = (conf, { required, multiple, __component }) => {
  if (required) {
    if (multiple) {
      return conf.min(1);
    }
    if (__component === 'form-input-types.checkbox') {
      return conf.oneOf([true], 'Field must be checked').required(<ErrorMessage type="required" />);
    }
    return conf.required(<ErrorMessage type="required" />);
  }
  return conf;
};

export const createValidationSchema = (obj) => {
  const validationShape = {};
  forEach(obj, (answerProps) => {
    const { name, __component, multiple } = answerProps;
    switch (__component) {
      case 'form-input-types.radio':
        validationShape[name] = withRequired(Yup.mixed(), answerProps);
        break;
      case 'form-input-types.checkbox':
        validationShape[name] = withRequired(Yup.bool().nullable(), answerProps);
        break;
      case 'form-input-types.select':
        validationShape[name] = withRequired(multiple ? Yup.array() : Yup.mixed(), answerProps);
        break;
      case 'form-input-types.slider':
        validationShape[name] = withRequired(Yup.mixed(), answerProps);
        break;
      default:
        validationShape[name] = withRequired(Yup.mixed(), answerProps);
        break;
    }
  });
  return Yup.object().shape(validationShape);
};
